import React from 'react';
import Table from 'react-bootstrap/Table';
import ActiviteProduit from '../../../../../common/src/entities/activite-produit.entity';
import {
    affichageComms,
    clientPrice,
    getCurrentPrice,
    getTotalCommission,
    getTotalSurfacturation,
} from './UtilsFunctionsProduits';
import PopoverSimple from '../../Common/PopoverSimple';
import DynamicTableCommission from './DynamicTableCommission';
import DynamicTable from './DynamicTable';
import { dateFormatter } from '../Utils/Log';

interface DynamicTableResumeProduitsProps {
    data: ActiviteProduit[];
}

const DynamicTableResumeProduits: React.FC<DynamicTableResumeProduitsProps> = ({ data }) => {
    return (
        <div>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Prix client</th>
                        <th>Méthode facturation</th>
                        <th>Commission</th>
                        <th>Profits$</th>
                        <th># Prix</th>
                        <th>Dernière modification</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row) => {
                        const currentPrice = getCurrentPrice(row.produit.historique_prix_produit);
                        return (
                            <>
                                <tr key={row.id}>
                                    <td>{row.produit.name} </td>
                                    <td>
                                        {currentPrice
                                            ? Number(clientPrice(currentPrice)).toFixed(2) + '$'
                                            : 'Non défini'}{' '}
                                    </td>
                                    <td>
                                        {currentPrice ? currentPrice.facturation?.methode_facturation : 'Non défini'}{' '}
                                    </td>
                                    <td>
                                        {currentPrice ? (
                                            <>
                                                <PopoverSimple
                                                    inList
                                                    texte={
                                                        <>
                                                            <DynamicTableCommission
                                                                title={'Table des commissions'}
                                                                data={currentPrice}
                                                            />
                                                        </>
                                                    }
                                                >
                                                    <u>{affichageComms(currentPrice) as any}</u>
                                                </PopoverSimple>
                                            </>
                                        ) : (
                                            'Non défini'
                                        )}
                                    </td>
                                    {currentPrice
                                        ? (
                                              Number(getTotalSurfacturation(currentPrice)) +
                                              Number(getTotalCommission(currentPrice))
                                          ).toFixed(2) + '$'
                                        : 'Non défini'}
                                    <td>
                                        {row.produit.historique_prix_produit ? (
                                            <>
                                                <PopoverSimple
                                                    inList
                                                    texte={
                                                        <>
                                                            <DynamicTable
                                                                title={''}
                                                                data={row.produit.historique_prix_produit}
                                                            />
                                                        </>
                                                    }
                                                >
                                                    <u>{row.produit.historique_prix_produit.length as any}</u>
                                                </PopoverSimple>
                                            </>
                                        ) : (
                                            'Non défini'
                                        )}
                                    </td>

                                    <td>
                                        {row.produit.date_derniere_modification
                                            ? dateFormatter(row.produit.date_derniere_modification)
                                            : 'Non modifié'}
                                    </td>
                                </tr>
                            </>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
};

export default DynamicTableResumeProduits;
